import React, { useId } from 'react';

export function PointingArrow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="107" height="35" viewBox="0 0 107 35" fill="none" {...props}>
      <path
        d="M1 27.2661C16.7695 28.2353 30.311 24.9451 39.3177 11.1566C42.3496 6.51503 43.5764 -1.23127 35.0602 1.6103C27.1492 4.24991 22.9187 15.9962 25.9917 23.5157C30.6031 34.8 44.0773 35.3579 54.4745 32.6359C70.56 28.4247 86.2996 22.8313 100.626 14.3956C103.544 12.6773 82.509 8.99914 89.5139 11.1566C94.4582 12.6794 98.9618 12.6909 104.075 12.6909C107.756 12.6909 105.402 13.9267 103.266 15.7593C99.7945 18.7376 96.3821 23.5469 95.2615 28.0332"
        stroke="#E1E4EA"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function NovuLogo() {
  const gradientId = useId();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="328" height="232" viewBox="0 0 328 232" fill="none">
      <g opacity="0.5">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M292.6 152.309C292.6 162.521 280.202 167.58 273.054 160.277L126.777 10.7707C147.089 3.62399 168.468 -0.018086 190 6.75293e-05C227.798 6.75293e-05 263.007 11.0438 292.6 30.0557V152.309ZM345.8 81.2251V152.309C345.8 210.199 275.512 238.866 235.03 197.481L77.7219 36.7057C30.59 71.2857 0 127.074 0 190C0 230.458 12.6469 267.959 34.2 298.775V228.071C34.2 170.181 104.488 141.514 144.97 182.899L302.064 343.449C349.315 308.893 380 253.033 380 190C380 149.542 367.353 112.041 345.8 81.2251ZM106.946 220.103L252.949 369.313C233.249 376.236 212.064 380 190 380C152.214 380 116.993 368.956 87.4 349.944V228.071C87.4 217.859 99.8094 212.8 106.946 220.103Z"
          fill={`url(#${gradientId})`}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M292.6 152.309C292.6 162.521 280.202 167.58 273.054 160.277L126.777 10.7707C147.089 3.62399 168.468 -0.018086 190 6.75293e-05C227.798 6.75293e-05 263.007 11.0438 292.6 30.0557V152.309ZM345.8 81.2251V152.309C345.8 210.199 275.512 238.866 235.03 197.481L77.7219 36.7057C30.59 71.2857 0 127.074 0 190C0 230.458 12.6469 267.959 34.2 298.775V228.071C34.2 170.181 104.488 141.514 144.97 182.899L302.064 343.449C349.315 308.893 380 253.033 380 190C380 149.542 367.353 112.041 345.8 81.2251ZM106.946 220.103L252.949 369.313C233.249 376.236 212.064 380 190 380C152.214 380 116.993 368.956 87.4 349.944V228.071C87.4 217.859 99.8094 212.8 106.946 220.103Z"
          fill="#F0F0F0"
          fillOpacity="0.15"
        />
      </g>
      <defs>
        <linearGradient id={gradientId} x1="4.92032" y1="68.506" x2="158.207" y2="160.1" gradientUnits="userSpaceOnUse">
          <stop stopColor="#EEEEEE" stopOpacity="0" />
          <stop offset="1" stopColor="#F9F9F9" />
        </linearGradient>
      </defs>
    </svg>
  );
}
